<template>
  <div v-show="!isHideLeftBar" class="play-left-bar" :class="{ hide: hide }">
    <a href="javascript:;" class="close" @click="hide = true"></a>
    <a
      href="javascript:;"
      class="close-btn"
      @click="
        hide = true
        $util.clickStat(`YXY/ZCYC`, `游戏页/左侧隐藏`)
      "
    ></a>
    <a
      href="javascript:;"
      class="open-btn"
      @click="
        hide = false
        $util.clickStat(`YXY/ZCZX`, `游戏页/左侧展现`)
      "
    ></a>
    <div class="box">
      <div class="user-info">
        <div class="userImg">
          <img :src="userInfo.avatar" />
        </div>
        <div>
          <div class="user-title">
            <em>{{ userInfo.nickname }}</em>
          </div>
          <div class="user-msg">
            <a
              target="blank"
              href="http://wan.xunlei.com/personal"
              @click="$util.clickStat(`YXY/ZHXX`, `游戏页/账号信息`)"
              >账号信息</a
            ><em>|</em
            ><a
              :href="
                `/recharge?game_id=${$route.params.game_id}&server_id=${
                  $route.query.server_id
                }&referfrom=${$route.query.referfrom || ''}&actfrom=${$route
                  .query.actfrom || ''}`
              "
              target="_blank"
              @click="$util.clickStat(`YXY/ZCCZ`, `游戏页/左侧充值`)"
              >充值</a
            >
          </div>
        </div>
      </div>
      <div class="server">
        <img :src="userInfo.avatar" />
        <span class="game-name">{{ curGameName.title }}</span>
        <span class="game-server">{{ curServer.title }}</span>
      </div>
      <div v-if="playLeftAd && (countdown > 0 || isAdShow)" class="active">
        <a
          :href="playLeftAd.JumpUrl"
          target="_blank"
          @click="$util.clickStat(`YXY/LQHY`, `游戏页/领取会员`)"
        >
          <img v-if="playLeftAd" :src="playLeftAd.AdImage" />
          <div class="cont">
            <div>
              <p class="t1">{{ playLeftAd.Description }}</p>
              <p v-show="countdown > 0" class="t2">{{ countDesc }}</p>
            </div>
          </div>
        </a>
      </div>
      <!-- 我的游戏 -->
      <div class="item mine-item show">
        <a href="javascript:;" class="item-title">我的游戏</a>
        <div class="cont">
          <dl class="list">
            <dt>最近玩过的游戏</dt>
            <dd
              v-for="(item, index) in (latest_game_list || []).slice(0, 3)"
              :key="index.game_id"
            >
              <a
                href="javascript:;"
                @click="
                  $util.gameStat(
                    item.game_id,
                    item.latest_game_list[0].server_id,
                    `YXY/WDYX/ZJYX${index + 1}`,
                    `游戏页/我的游戏/最近游戏${index + 1}`
                  )
                "
                ><em>{{ item.title }}</em>
                <em
                  v-if="
                    Array.isArray(item.latest_game_list) &&
                      item.latest_game_list[0].title
                  "
                  >{{ item.latest_game_list[0].title }}</em
                ></a
              >
            </dd>
          </dl>
          <dl class="list">
            <dt>热门游戏推荐</dt>
            <dd
              v-for="(item, index) in (hotRecommend_list || []).slice(0, 3)"
              :key="index.game_id"
            >
              <a
                href="javascript:;"
                @click="
                  $util.gameStat(
                    item.game_id,
                    item.server_list[0].server_id,
                    `YXY/WDYX/RMTJ${index + 1}`,
                    `游戏页/我的游戏/热门推荐${index + 1}`
                  )
                "
                ><em>{{ item.title }}</em
                ><em>{{ item.server_list[0].title }}</em></a
              >
            </dd>
          </dl>
        </div>
      </div>
      <!-- 换服 -->
      <div class="item last-item">
        <a
          href="javascript:;"
          class="item-title"
          @click="$util.clickStat(`YXY/HF`, `游戏页/换服`)"
          >换服</a
        >
        <div class="cont">
          <dl class="list">
            <dt>最近玩过的区服</dt>
            <dd
              v-for="(item, index) in (latest_server_list || []).slice(0, 3)"
              :key="index.server_id"
            >
              <a
                href="javascript:;"
                @click="
                  $util.gameStat(
                    item.game_id,
                    item.latest_server_list[0].server_id,
                    `YXY/HF/ZJYX${index + 1}`,
                    `游戏页/换服/最近游戏${index + 1}`
                  )
                "
              >
                <em
                  v-if="
                    Array.isArray(item.latest_server_list) &&
                      item.latest_server_list[0] &&
                      item.latest_server_list[0].title
                  "
                  >{{ item.latest_server_list[0].title }}</em
                >
              </a>
            </dd>
          </dl>
          <dl class="list">
            <dt>最新区服</dt>
            <dd
              v-for="(item, index) in new_server_list || []"
              :key="index.server_id"
            >
              <a
                href="javascript:;"
                @click="
                  $util.gameStat(
                    item.game_id,
                    item.server_id,
                    `YXY/HF/ZXQF${index + index}`,
                    `游戏页/换服/最新区服${index + index}`
                  )
                "
              >
                <em>{{ item.title }}</em>
                <span v-if="index < 1"
                  ><strong>{{ convertTime(item) }}日开启</strong></span
                >
                <span v-else>火爆开启</span>
              </a>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 福利领取 -->
      <div class="item welfare-item">
        <a
          href="javascript:;"
          class="item-title"
          @click="$util.clickStat(`YXY/FLLQ`, `游戏页/福利领取`)"
          >福利领取</a
        >
        <div class="cont">
          <dl class="list">
            <dt>新手礼包</dt>
            <dd v-for="(item, index) in vip_level_search || []" :key="index">
              <a
                href="javascript:;"
                @click="
                  $util.clickStat(
                    `YXY/FLLQ/XSLB${index + 1}`,
                    `游戏页/福利领取/新手礼包${index + 1}`
                  )
                  $util.goGiftDetailPlaySideBar(item)
                "
                >{{ item.title }}</a
              >
            </dd>
          </dl>
          <dl class="list">
            <dt>VIP礼包</dt>
            <dd v-for="(item, index) in vip_level_search2 || []" :key="index">
              <a
                href="javascript:;"
                @click="
                  $util.clickStat(
                    `YXY/FLLQ/VIPLB${index + 1}`,
                    `游戏页/福利领取/VIP礼包${index + 1}`
                  )
                  $util.goGiftDetailPlaySideBar(item)
                "
                >{{ item.title }}</a
              >
            </dd>
          </dl>
          <a
            href="http://wan.xunlei.com/gifts"
            target="blank"
            class="more"
            @click="
              $util.clickStat(`YXY/FLLQ/GDFL`, `游戏页/福利领取/更多福利`)
            "
            >更多福利</a
          >
        </div>
      </div>
      <!-- 游戏攻略 -->
      <div class="item">
        <a
          :href="`/game-offical/${$route.params.game_id}/notice/list?type=3`"
          class="item-title"
          target="_blank"
          @click="$util.clickStat(`YXY/YXGL`, `游戏页/游戏攻略`)"
          >游戏攻略</a
        >
      </div>
      <!-- 急速登录器 -->
      <div v-if="$store.state.game.info.jump_url" class="item">
        <a
          :href="$store.state.game.info.jump_url"
          class="item-title"
          target="_blank"
          @click="$util.clickStat(`YXY/DLQ`, `游戏页/登陆器`)"
          >极速登录器</a
        >
      </div>
      <!-- 收藏游戏 -->
      <div class="item">
        <a
          href="javascript:;"
          class="item-title"
          @click="
            addFav()
            $util.clickStat(`YXY/ZCSC`, `游戏页/左侧收藏`)
          "
          >收藏游戏中心</a
        >
      </div>
      <!-- VIP人工客服 -->
      <div class="item">
        <a
          href="javascript:;"
          class="item-title"
          target="_blank"
          @click="
            _openCustomerService()
            $util.clickStat(`YXY/ZCKF`, `游戏页/左侧客服`)
          "
          >VIP人工客服</a
        >
      </div>
      <!-- 玩家守则 -->
      <div class="item">
        <a
          href="https://wan.xunlei.com/rules"
          class="item-title"
          target="_blank"
          @click="$util.clickStat(`YXY/ZCWJSZ`, `游戏页/左侧玩家守则`)"
          >玩家守则</a
        >
      </div>
      <!-- 自定义 -->
      <div v-if="leftToolbarAdConf.Name" class="item custom-item">
        <a
          :href="leftToolbarAdConf.JumpUrl"
          class="item-title"
          target="_blank"
          @click="$util.clickStat(`YXY/ZCZDY`, `游戏页/左侧自定义`)"
          >{{ leftToolbarAdConf.Name }}</a
        >
      </div>
    </div>
    <!-- 推广 -->
    <div class="act-pop" :class="{ hide: actPopHide }">
      <i
        class="wpop-close"
        style="background: #fff"
        @click.stop="actPopHide = true"
      ></i>
      <img :src="popConf.img_url" @click="goAct" />
    </div>
    <!-- 会员推广位 -->
    <div
      v-if="playGameTopAd"
      class="vip-act-pop"
      :class="{ hide: !vipActPopHide }"
    >
      <i
        class="wpop-close"
        style="background: #fff"
        @click.stop="closeTopAd"
      ></i>
      <!-- new -->
      <a
        :href="playGameTopAd.jump_url"
        target="_blank"
        @click="$util.clickStat(`YXY/LQHY`, `游戏页/领取会员`)"
        ><img :src="playGameTopAd.ad_image"
      /></a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import $ from 'jquery'
import { openCustomerService, getUrlParam } from '~/utils/util'
export default {
  data() {
    return {
      hide: false,
      gameInfo: {},
      actPopHide: true,
      vipActPopHide: false, // 顶部广告
      popConf: {},
      leftToolbarAdConf: {},
      latest_game_list: [],
      latest_server_list: [],
      new_server_list: [],
      hotRecommend_list: [],
      gameWelfare_list: [],
      // playLeftAd_list: [],
      // playGameTop_list: [],
      countDown_list: [],
      playLeftAd: null,
      playGameTopAd: [],
      countdown: null, // 倒计时
      countDesc: '00:00:00',
      timeTemp: 0,
      count: 0,
      isHideLeftBar: true,
      close: false, // 是否手动关闭
      isAdShow: false
    }
  },
  computed: {
    ...mapGetters('player', ['curServer', 'curGameName']),
    userInfo() {
      return this.$store.state.userInfo
    },
    vip_level_search() {
      if (!this.vip_level) {
        return (this.gameWelfare_list || []).filter((val) => {
          return val.vip_level === 0
        })
      } else {
        return ''
      }
    },
    vip_level_search2() {
      if (!this.vip_level) {
        return (this.gameWelfare_list || []).filter((val) => {
          return val.vip_level !== 0
        })
      } else {
        return ''
      }
    }
    // curServer () {
    //   return this.$store.state.playerInfo.curServer
    // },
  },
  watch: {
    curGameName: {
      // immediate: true,
      handler(val) {
        console.error(val)
      }
    }
  },
  created() {
    /* 侧边栏广告位 */
    if (process.client) {
      this.$request('playLeftAd', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = {}) => {
        this.playLeftAd = data || {}
      })
    }
    /* 头部广告位 */
    if (process.client) {
      this.$request('playGameTopAd', {
        body: {
          game_id: this.$route.params.game_id,
          server_id: this.$route.query.server_id
        }
      }).then((data = {}) => {
        this.playGameTopAd = data || {}
        // 开始广告倒计时
        this.timeTemp = this.playGameTopAd.show_at
        this.toggleTopAd()
      })
    }
    /* 侧边栏广告位倒计时 */
    if (process.client) {
      this.$request('playLeftAdConfig', {
        body: {
          game_id: this.$route.params.game_id,
          server_id: this.$route.query.server_id
        }
      }).then((data = {}) => {
        const { autoOff = true, countdown = 0 } = data
        this.isAdShow = !autoOff
        this.countdown = countdown
        this.getDateTime()
        // 开始倒计时
      })
    }
    /* 最近玩过的游戏 */
    if (process.client) {
      this.$request('gameRecently').then(
        (data) => (this.latest_game_list = data || [])
      )
    }
    /* 热门游戏推荐 */
    if (process.client) {
      this.$request('hotRecommend').then(
        (data) => (this.hotRecommend_list = data || [])
      )
    }
    /* 最近玩过的区服 */
    if (process.client) {
      this.$request('gameRecently', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = [{}]) => {
        this.latest_server_list = data || []
      })
    }
    /* 最新区服 */
    if (process.client) {
      this.$request('sideBarNewServer', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = [{}]) => {
        this.new_server_list = data || []
      })
    }
    /* 礼包 */
    if (process.client) {
      this.$request('giftsPackageList', {
        body: {
          game_ids: this.$route.params.game_id
        }
      }).then((data = []) => (this.gameWelfare_list = data.set_list))
    }
    /* 左侧自定义 */
    if (process.client) {
      Promise.all([
        this.$request('gameLeftToolbarAd'),
        this.$request('getTime')
      ]).then(([data, timeRes]) => {
        if (data && data.Name && timeRes.time) {
          const nowTime = timeRes.time
          if (
            data.StartTime &&
            (this.$dayjs(nowTime).isAfter(this.$dayjs(data.StartTime)) ||
              this.$dayjs(nowTime).isSame(this.$dayjs(data.StartTime))) &&
            data.EndTime &&
            this.$dayjs(nowTime).isBefore(this.$dayjs(data.EndTime))
          ) {
            this.leftToolbarAdConf = data
            const countDown = this.$dayjs(data.EndTime).diff(
              this.$dayjs(nowTime)
            )
            setTimeout(() => {
              this.leftToolbarAdConf = {}
            }, countDown)
          }
        }
      })
    }
  },
  mounted() {
    this.getLeftBarStatus()
    // 2020年12月08日 星期二 end
    this.getPopConf()
    $('.item').on('click', function() {
      $(this)
        .addClass('show')
        .siblings()
        .removeClass('show')
    })
  },
  methods: {
    getLeftBarStatus() {
      const isHideLeftBar = getUrlParam('hideLeftBar') || false
      this.isHideLeftBar = isHideLeftBar
    },
    // 手动关闭广告
    closeTopAd() {
      this.close = true
      this.vipActPopHide = false
    },
    // 头部广告展示隐藏
    toggleTopAd() {
      if (this.close) {
        // 如果手动关了就不倒计时了
        return false
      }
      if (this.timeTemp <= 0) {
        this.vipActPopHide = !this.vipActPopHide
        if (this.vipActPopHide) {
          this.timeTemp = this.playGameTopAd.hide_at
          this.toggleTopAd()
        }
        return false
      }
      this.timeTemp -= 1
      // console.log(this.timeTemp)
      setTimeout(this.toggleTopAd, 1000)
    },
    // 侧边栏倒计时
    getDateTime() {
      this.countdown -= 1
      if (this.countdown > 0) {
        const h = parseInt(this.countdown / 3600)
        const m = parseInt((this.countdown % 3600) / 60)
        const s = this.countdown % 60
        const arr = [h, m, s]
        for (const i in arr) {
          arr[i] = arr[i] < 10 ? '0' + arr[i] : arr[i]
        }
        this.countDesc = arr.join(':')
        setTimeout(this.getDateTime, 1000)
      } else {
        this.countDesc = '00:00:00'
      }
    },
    // 收藏
    addFav() {
      try {
        window.external.addFavorite(location.href, document.title)
      } catch (e) {
        try {
          window.sidebar.addPanel(location.href, document.title, '')
        } catch (e) {
          alert(
            '抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加'
          )
        }
      }
    },
    // 转换时间
    convertTime({ opened_at }) {
      return dayjs(opened_at).format('DD')
    },
    // 推广
    getPopConf() {
      axios
        .get(
          'https://static2-youxi.a.88cdn.com/config/play_page_pop-prod.json?_t=' +
            Date.now()
        )
        .then(({ data }) => {
          if (data && data.img_url) {
            if (
              data.open_at &&
              this.$dayjs().isAfter(this.$dayjs(data.open_at)) &&
              data.close_at &&
              this.$dayjs().isBefore(this.$dayjs(data.close_at))
            ) {
              this.actPopHide = false
              this.popConf = data
              setTimeout(() => {
                this.actPopHide = true
              }, data.duration || 5000)
            }
          }
        })
    },
    jump(url) {
      window.open(url)
    },
    goAct() {
      window.open(this.popConf.jump_url)
    },
    _openCustomerService() {
      openCustomerService()
    }
  }
}
</script>
